import uiRouter from 'angular-ui-router';
import mySolidarityComponent from './mySolidarity.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import ongsList from './ongsList/ongsList';

let mySolidarityModule = angular.module('solidarity.mySolidarity', [
  uiRouter, ongsList
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.SOLIDARITY.MY_SOLIDARITY, {
        url: ROUTES.SOLIDARITY.MY_SOLIDARITY,
        component: 'mySolidarity',
        data: {
          requiresAuth: true,
        },
      });
  })

  .component('mySolidarity', mySolidarityComponent)

  .name;

export default mySolidarityModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/mySolidarity.js